import React from 'react'

import classes from '../UI/Cards/Automations/CreateRule/SelectOutputs.module.css'
import Button2 from '../UI/Button/Button2';


const DEFAULT_OUTPUT_PINS = [
    { pinNumber: "5",  pinName: "Output 1" },
    { pinNumber: "6",  pinName: "Output 2" },
    { pinNumber: "13", pinName: "Output 3" },
    { pinNumber: "19", pinName: "Output 4" },
    { pinNumber: "25", pinName: "Output 5" },
    { pinNumber: "26", pinName: "Output 6" },
    { pinNumber: "27", pinName: "Output 7" },
    { pinNumber: "28", pinName: "Output 8" },
];

const SelectOutputsForMassSchedule = ({ setModalPageIndex, selectedOutputs, setSelectedOutputs, selectedSites }) => {

    const hasIncompatibleSites = selectedSites.some(site => site.type !== 'S')
    const AVAILABLE_OUTPUT_PINS = hasIncompatibleSites
        ? DEFAULT_OUTPUT_PINS.slice(0, 4) // Outputs 1–4
        : DEFAULT_OUTPUT_PINS;

    const handleSelectOutput = (pinNumber) => {
        console.log(pinNumber);
        console.log(selectedOutputs);
        setSelectedOutputs(prev =>
            prev.includes(pinNumber)
                ? prev.filter(p => p !== pinNumber)
                : [...prev, pinNumber]
        );
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "15px" }}>

            <div style={{ position: "absolute", right: "40px", top: "60px" }}>
                <button className={classes.nextButton} disabled={selectedOutputs.length === 0} onClick={() => setModalPageIndex(1)}>
                    {">"}
                </button>
            </div>

            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                <h3 style={{ color: "#6e6e6e" }}>{`Which switch do you want the schedule on?`}</h3>
                <br />
            
                <ul style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                    {AVAILABLE_OUTPUT_PINS.map(({ pinNumber, pinName }) => {
                        const isSelected = selectedOutputs.includes(pinNumber);
                        return (
                            <Button2
                                key={pinNumber}
                                onClick={() => handleSelectOutput(pinNumber)}
                                style={{
                                    minWidth: "300px",
                                    minHeight: "40px",
                                    backgroundColor: isSelected ? "var(--Primary-Color)" : undefined,
                                    color: isSelected ? "white" : undefined,
                                    border: isSelected ? "2px solid lightblue" : undefined,
                                }}
                            >
                                {pinName}
                            </Button2>
                        );
                    })}
                </ul>

                { AVAILABLE_OUTPUT_PINS.length == 4 && <p style={{textAlign:'center', fontWeight:400, fontSize:"13px"}}>Why are only 4 outputs available?
                    One or more selected sites do not support 8 outputs.</p>
                }

            </div>

        </div>
    )
}

export default SelectOutputsForMassSchedule;